import axios from "axios";

// const API_BASE_URL = "https://test.txtconnect.net/api";
const API_BASE_URL = "https://api.txtconnect.net/api";
//latest  commit 
//api commit 


const apiKeyRequests = {
  getApiKey: (token) =>
    axios.get(`${API_BASE_URL}/user/apikey`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  regenerateApiKey: (token) =>
    axios.post(
      `${API_BASE_URL}/user/apikey/regenerate`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
};

export default apiKeyRequests;
